import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class SystemSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');

    this.slider = null;
    this.option = {
      autoWidth: true,
      pagination: false,
      arrows: false,
      type: 'loop',
      gap: `min(${9 / 16}rem, ${9 / 375 * 100}vw)`,
      rewind: true,
      loop: true,
      speed: 1200,
      arrows: true,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          gap: `min(${20 / 16}rem, ${20 / 1440 * 100}vw)`,
        }
      }
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    this.slider.mount();
  }
}

export default SystemSlides